import script from "./CrudFechaRango.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudFechaRango.vue?vue&type=script&setup=true&lang=js"

import "./CrudFechaRango.vue?vue&type=style&index=0&id=636a8c4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636a8c4f"]])

export default __exports__